import * as corosSportConfig from '@coros/sport-config';
const { INDOOR_CLIMB_BOULDERING_CHART_NAME } = corosSportConfig.sport.climb;
import * as d3 from 'd3';

export const CustomChartItems = {
  // 户外跑
  Run: [
    // 配速
    { chartName: 'Pace' },
    // 功率
    {
      chartName: 'Power'
    },
    // 跑步效率
    { chartName: 'Run_Efficiency' },
    // 踏地时间
    { chartName: 'Ground_Time' },
    // 左右平衡
    { chartName: 'L_R_Balance' },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 垂直步幅比
    { chartName: 'Stride_Ratio' },
    // 垂直振幅
    { chartName: 'Stride_Height' },
    // 步幅
    {
      chartName: 'Stride_Length'
    },
    // 姿势功率
    { chartName: 'Form_Power' },
    // 踏地角度
    { chartName: 'Landing_Angle' },
    // 下肢刚度
    { chartName: 'Leg_Stiffness' },
    // 地反力峰值
    { chartName: 'Vertical_Ground_Reaction_Force' },
    // 风阻系数
    { chartName: 'Air_Power' },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 等价配速
    {
      chartName: 'Adjusted_Pace'
    },
    { chartName: 'Impact_Loading_Rate' }
  ],
  // 跑步机
  Indoor_Run: [
    // 配速
    { chartName: 'Pace' },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏地时间
    { chartName: 'Ground_Time' },
    // 左右平衡
    { chartName: 'L_R_Balance' },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 垂直步幅比
    { chartName: 'Stride_Ratio' },
    // 垂直振幅
    { chartName: 'Stride_Height' },
    // 步幅
    { chartName: 'Stride_Length' },
    // 姿势功率
    { chartName: 'Form_Power' },
    // 下肢刚度
    { chartName: 'Leg_Stiffness' },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    { chartName: 'Impact_Loading_Rate' },
    { chartName: 'Slope' }
  ],
  // 越野跑
  Trail_Run: [
    // 配速
    { chartName: 'Pace' },
    // 功率
    {
      chartName: 'Power'
    },
    // 跑步效率
    { chartName: 'Run_Efficiency' },
    // 踏地时间
    { chartName: 'Ground_Time' },
    // 左右平衡
    { chartName: 'L_R_Balance' },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 垂直步幅比
    { chartName: 'Stride_Ratio' },
    // 垂直振幅
    { chartName: 'Stride_Height' },
    // 步幅
    {
      chartName: 'Stride_Length'
    },
    // 姿势功率
    { chartName: 'Form_Power' },
    // 下肢刚度
    { chartName: 'Leg_Stiffness' },
    // 风阻系数
    { chartName: 'Air_Power' },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 等价配速
    {
      chartName: 'Adjusted_Pace'
    },
    { chartName: 'Impact_Loading_Rate' }
  ],
  // 操场跑圈
  Track_Run: [
    // 配速
    { chartName: 'Pace' },
    // 功率
    {
      chartName: 'Power'
    },
    // 跑步效率
    { chartName: 'Run_Efficiency' },
    // 踏地时间
    { chartName: 'Ground_Time' },
    // 左右平衡
    { chartName: 'L_R_Balance' },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 垂直步幅比
    { chartName: 'Stride_Ratio' },
    // 垂直振幅
    { chartName: 'Stride_Height' },
    // 步幅
    {
      chartName: 'Stride_Length'
    },
    // 姿势功率
    { chartName: 'Form_Power' },
    // 下肢刚度
    { chartName: 'Leg_Stiffness' },
    // 风阻系数
    { chartName: 'Air_Power' },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    { chartName: 'Impact_Loading_Rate' }
  ],
  // 徒步
  Hike: [
    // 速度
    { chartName: 'Speed' },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 登山
  Mtn_Climb: [
    // 速度
    { chartName: 'Speed' },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 骑行
  Bike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 头盔骑行
  Helmet_Bike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 室内骑行
  Indoor_Bike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 公路 e-bike
  Road_Ebike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 砾石路骑行
  Gravel_Road_Bike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 山地骑行
  Mountain_Riding: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 山地 e-bike
  Mountain_Ebike: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 踏频
    {
      chartName: 'Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 齿轮比
    {
      chartName: 'Gear_Ratio'
    },
    // 左右平衡
    {
      chartName: 'L_R_Balance'
    }
  ],
  // 泳池游泳
  Pool_Swim: [
    // 配速
    {
      chartName: 'Pace',
      config: {
        curve: d3.curveStepAfter
      }
    },
    // 划频
    {
      chartName: 'Swim_StrokeRate'
    },
    // 划次
    {
      chartName: 'Strokes',
      config: {
        curve: d3.curveStepAfter
      }
    },
    // SWOLF
    {
      chartName: 'SWOLF',
      config: {
        curve: d3.curveStepAfter
      }
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 水温
    {
      chartName: 'Water_Temperature'
    }
  ],
  // 公开水域
  Open_Water: [
    // 配速
    { chartName: 'Pace' },
    // 划频
    {
      chartName: 'Swim_StrokeRate'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 水温
    {
      chartName: 'Water_Temperature'
    }
  ],
  // 铁三
  Triathlon: [
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 健身
  Strength: [
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 室内有氧
  Gym_Cardio: [
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 户外有氧
  GPS_Cardio: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 雪场双板
  Ski: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 雪场单板
  Snowboard: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 越野滑雪
  XC_Ski: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 等价速度
    {
      chartName: 'Adjusted_Speed'
    }
  ],
  // 登山滑雪
  Ski_Touring: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 等价速度
    {
      chartName: 'Adjusted_Speed'
    }
  ],
  // 登山滑雪（旧）
  Ski_Touring_Old: [
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 组合运动
  Multi_Sport: [
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 竞速帆板
  Speedsurfing: [
    // 速度
    { chartName: 'Speed' },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 帆板
  Windsurfing: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 赛艇
  Row: [
    // 配速
    {
      chartName: 'Pace'
    },
    // 桨频
    {
      chartName: 'Row_Stroke_Rate'
    },
    // 划距
    {
      chartName: 'Stroke_Length'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 划船机
  Indoor_Row: [
    // 配速
    {
      chartName: 'Pace'
    },
    // 功率
    {
      chartName: 'Power'
    },
    // 桨频
    {
      chartName: 'Row_Stroke_Rate'
    },
    // 划距
    {
      chartName: 'Stroke_Length'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 激流运动
  Whitewater: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 桨频
    {
      chartName: 'Row_Stroke_Rate'
    },
    // 划距
    {
      chartName: 'Stroke_Length'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 静水运动
  Flatwater: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 桨频
    {
      chartName: 'Row_Stroke_Rate'
    },
    // 划距
    {
      chartName: 'Stroke_Length'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 多段攀登
  Multi_Pitch: [
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 攀登
  Climb: [
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 难度
    {
      chartName: 'Grade',
      config: { curve: d3.curveStepAfter }
    },
    // 温度
    {
      chartName: 'TEMPC'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 室内攀岩
  IndoorClimb: [
    // 难度
    {
      chartName: INDOOR_CLIMB_BOULDERING_CHART_NAME,
      config: { curve: d3.curveStepAfter }
    },
    // 海拔
    {
      chartName: 'ElevationForIndoorClimbBouldering'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 抱石
  Bouldering: [
    // 海拔
    {
      chartName: 'ElevationForIndoorClimbBouldering'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 难度
    {
      chartName: INDOOR_CLIMB_BOULDERING_CHART_NAME,
      config: { curve: d3.curveStepAfter }
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  // 健走
  Walk: [
    // 配速
    {
      chartName: 'Pace'
    },
    // 步频
    {
      chartName: 'Step_Cadence'
    },
    // 步幅
    {
      chartName: 'Stride_Length'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ],
  Jump_Rope: [
    // 速度
    {
      chartName: 'Speed'
    },
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    },
    // 连跳（前端补值实现数据连续性）
    {
      chartName: 'Continuous_Jump',
      config: {
        curve: d3.curveStepAfter
      }
    }
  ],
  // 爬楼 902
  Climb_Stairs: [
    // 心率
    {
      chartName: 'Heart_Rate'
    },
    // 海拔
    {
      chartName: 'Elevation'
    },
    // 体温
    {
      chartName: 'Body_Temperature'
    }
  ]
};
